<template>
  <div class="row mx-0 justify-content-center">
    <div class="col-xxl-3 text-center col-xl-4 col-lg-6 col-md-6 col-10 pt-2">
      <img alt="Makbill Logo" src="/images/makbilllogo.png" class="img-fluid" />
    </div>
  </div>
  <div class="row mx-0 pt-2 justify-content-center">
    <div v-if="loading" class="loader-container">
      <div class="spinner"></div>
    </div>
    <div v-else class="col-xl-8 col-md-10 col-sm-12 m-4">
      <form class="form-register" @submit.prevent="verifyingSignature">
        <div class="card">
          <h4 class="ms-4 mt-4 verification-form">Verify the Documents</h4>

          <!-- Step Container -->
          <div class="step-container">
            <div
              class="step ms-2"
              :class="{
                active: selectedStep === 'PAN Verification',
                disabled:
                  stepVerified.pan || userDetails.pancard_verified !== 0,
              }"
              @click="selectStep('PAN Verification')"
            >
              <div class="icon"><i class="fa fa-id-card text-white"></i></div>
              <p class="ms-3">PAN Verification</p>
            </div>
            <div
              class="step"
              :class="{
                active: selectedStep === 'Aadhaar Verification',
                disabled:
                  stepVerified.aadhaar ||
                  userDetails.pancard_verified === 0 ||
                  userDetails.aadhar_verified !== 0,
              }"
              @click="selectStep('Aadhaar Verification')"
            >
              <div class="icon">
                <i class="fa fa-address-card text-white"></i>
              </div>
              <p>Aadhaar Verification</p>
            </div>
            <div
              v-if="userType !== 1"
              class="step"
              :class="{
                active: selectedStep === 'GSTIN Verification',
                disabled:
                  stepVerified.gstin ||
                  userDetails.aadhar_verified === 0 ||
                  userDetails.gstin_verified !== 0,
              }"
              @click="selectStep('GSTIN Verification')"
            >
              <div class="icon">
                <i class="fa fa-file-invoice text-white"></i>
              </div>
              <p>GSTIN Verification</p>
            </div>
            <div
              class="step me-3"
              :class="{
                active: selectedStep === 'Document Verification',
                disabled:
                  stepVerified.document ||
                  userDetails.gstin_verified === 0 ||
                  userDetails.document_verified !== 0,
              }"
              @click="selectStep('Document Verification')"
            >
              <div class="icon me-3">
                <i class="fa fa-file-pdf text-white"></i>
              </div>
              <p>Document Verification</p>
            </div>
          </div>
          <hr />
          <div class="form-container">
            <!-- PAN Verification Step -->
            <div class="m-5">
              <div v-if="selectedStep === 'PAN Verification'">
                <h5>PAN Verification</h5>
                <div class="row">
                  <div class="col-lg-5 col-md-7 col-sm-12">
                    <llp-label id="panNumber">Pan Number:</llp-label>
                    <llp-input
                      id="panNumber"
                      class="w-100"
                      autocomplete="off"
                      v-model="panNumber"
                      :errors="validator.panNumber.$errors"
                    ></llp-input>
                  </div>
                  <div class="col-lg-5 col-md-7 col-sm-12">
                    <llp-label id="panHolderName"
                      >Name: *(name should be in pan card)</llp-label
                    >
                    <llp-input
                      id="panHolderName"
                      class="w-100"
                      autocomplete="off"
                      v-model="panHolderName"
                      :errors="validator.panHolderName.$errors"
                    ></llp-input>
                  </div>
                </div>
              </div>

              <!-- Aadhaar Verification Step -->
              <div v-if="selectedStep === 'Aadhaar Verification'">
                <h5>Aadhaar Verification</h5>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <llp-label id="aadhaarNumber">Aadhaar Number:</llp-label>
                    <llp-input
                      id="aadhaarNumber"
                      class="w-100"
                      autocomplete="off"
                      v-model="aadhaarNumber"
                      :errors="validator.aadhaarNumber.$errors"
                    ></llp-input>
                  </div>
                </div>
              </div>

              <!-- GSTIN Verification Step -->
              <div v-if="selectedStep === 'GSTIN Verification'">
                <h5>GSTIN Verification</h5>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <llp-label id="gstinNumber">GSTIN Number:</llp-label>
                    <llp-input
                      id="gstinNumber"
                      class="w-100"
                      autocomplete="off"
                      v-model="gstNumber"
                      :errors="validator.gstNumber.$errors"
                    ></llp-input>
                  </div>
                </div>
              </div>

              <!-- Document Verification Step -->
              <div v-if="selectedStep === 'Document Verification'">
                <h5>Document Verification</h5>
                <div :style="{ width: '100%', height: '100%' }">
                  <div
                    :style="{
                      padding: '15px',
                      border: '2px solid gray',
                      borderRadius: '10px',
                      width: '100%',
                      padding: '15px',
                      maxHeight: '400px',
                      overflowY: 'auto',
                    }"
                  >
                    <div
                      :style="{
                        width: '100%',
                        'margin-top': '4px',
                        display: 'flex',
                      }"
                    >
                      <div :style="{ width: '100%' }">
                        <p
                          :style="{
                            color: '#fff',
                            'font-weight': '400',
                            'font-size': '14px',
                            'line-height': '1.6',
                            'white-space': 'pre-wrap',
                            'word-wrap': 'break-word',
                          }"
                        >
                          {{ termsAndConditionsText }}
                        </p>
                      </div>
                    </div>

                    <div v-html="documentList" class="white-text"></div>

                    <!-- Flex container for checkbox and submit button -->
                    <div
                      :style="{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '10px',
                      }"
                    >
                      <input
                        type="checkbox"
                        id="agree"
                        v-model="isAgreed"
                        :disabled="isSubmitting"
                        :style="{ marginRight: '10px' }"
                      />
                      <label for="agree" :style="{ marginRight: '20px' }"
                        >I agree to the terms and conditions.</label
                      >

                      <!-- Submit Button -->
                      <button
                        :style="{
                          backgroundColor: '#240253',
                          color: 'white',
                          padding: '12px 30px',
                          border: 'none',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          fontSize: '14px',
                          marginLeft: '10px',
                        }"
                        :disabled="!isAgreed || isSubmitting"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Next Button -->
              <div class="row mt-4">
                <div
                  class="col-lg-3 col-md-4 col-sm-3"
                  v-if="selectedStep !== 'Document Verification'"
                >
                  <llp-button
                    :loadSpinner="documentVerificationSpinner"
                    classNames="btn-secondary text-white new-btn"
                    type="button"
                    @click="VerifyDocuments()"
                    >Next Step</llp-button
                  >
                </div>
                <div
                  class="col-lg-3 col-md-4 col-sm-3"
                  v-if="selectedStep !== 'Document Verification'"
                >
                  <llp-button
                    :loadSpinner="false"
                    classNames="btn-secondary text-white new-btn"
                    type="button"
                    @click="BackToLogin()"
                    >Back To Login</llp-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import {
  helpers,
  required,
  numeric,
  maxLength,
  minLength,
} from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import ErrorService from "../../services/error.service";
import NetworkService from "../../services/network.service.js";
export default {
  setup: () => ({ validator: useVuelidate() }),
  data() {
    return {
      id: this.$route.query.id,
      token: this.$route.query.token,
      selectedStep: "PAN Verification",
      panNumber: "",
      panHolderName: "",
      aadhaarNumber: "",
      gstNumber: "",
      userType: "",
      panRegex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
      stepVerified: {
        pan: false,
        aadhaar: false,
        gstin: false,
        document: false,
      },
      userDetails: {},
      isAgreed: false,
      isSubmitting: false,
      requestData: "",
      documentList: [],
      loading: true,
      documentVerificationSpinner: false,
    };
  },

  validations() {
    const validations = {};

    // PAN Verification Step
    if (this.selectedStep === "PAN Verification") {
      validations.panNumber = {
        required: helpers.withMessage("PAN number is required.", required),
        panFormat: helpers.withMessage(
          "PAN number must be in the format ABCDE1234F.",
          (value) => this.panRegex.test(value)
        ),
      };
      validations.panHolderName = {
        required: helpers.withMessage("Pan holder name is required.", required),
      };
    }

    // Aadhaar Verification Step
    if (this.selectedStep === "Aadhaar Verification") {
      validations.aadhaarNumber = {
        required: helpers.withMessage("Aadhaar number is required.", required),
        numeric: helpers.withMessage(
          "Aadhaar number must contain only numbers.",
          numeric
        ),
        minLength: helpers.withMessage(
          "Aadhaar number must be exactly 12 digits.",
          minLength(12)
        ),
        maxLength: helpers.withMessage(
          "Aadhaar number must be exactly 12 digits.",
          maxLength(12)
        ),
      };
    }

    // GSTIN Verification Step
    if (this.selectedStep === "GSTIN Verification") {
      validations.gstNumber = {
        required: helpers.withMessage("GST number is required.", required),
      };
    }

    // Document Verification Step
    if (this.selectedStep === "Document Verification") {
      validations.documentType = {
        required: helpers.withMessage("Document type is required.", required),
      };
    }

    return validations;
  },

  mounted() {
    this.CheckingVerificationDoneOrNot();
    this.fetchDocumentList();
  },

  methods: {
    selectStep(step) {
      // Only allow the user to proceed to the next step if the previous step is verified
      if (step === "Aadhaar Verification" && !this.stepVerified.pan) {
        return;
      }
      if (step === "GSTIN Verification" && !this.stepVerified.aadhaar) {
        return;
      }
      if (step === "Document Verification" && !this.stepVerified.gstin) {
        return;
      }

      // Allow navigation to the selected step if it's not verified yet
      if (this.stepVerified[step.toLowerCase()] === false) {
        this.selectedStep = step;
      }
    },

    async CheckingVerificationDoneOrNot() {
      try {
        const verificationResponse = await NetworkService.get(
          `verification/${this.id}/${this.token}`
        );
        this.userDetails = verificationResponse.user_data.user_details;
        this.userType = verificationResponse.user_data.usertype;
        // Step verification statuses
        this.stepVerified.pan = this.userDetails.pancard_verified === 1;
        this.stepVerified.aadhaar = this.userDetails.aadhar_verified === 1;
        this.stepVerified.gstin = this.userDetails.gstin_verified === 1;
        this.stepVerified.document = this.userDetails.document_verified === 1;
        if (this.userType === 1) {
          if (this.stepVerified.pan && this.stepVerified.aadhaar) {
            this.selectedStep = "Document Verification";
          } else if (this.stepVerified.pan) {
            this.selectedStep = "Aadhaar Verification";
          } else {
            this.selectedStep = "PAN Verification";
          }
        } else {
          // Regular flow for other user types
          if (this.stepVerified.pan) {
            if (this.stepVerified.aadhaar) {
              if (this.stepVerified.gstin) {
                // If GSTIN is verified, go directly to Document Verification
                this.selectedStep = "Document Verification";
              } else {
                this.selectedStep = "GSTIN Verification";
              }
            } else {
              this.selectedStep = "Aadhaar Verification";
            }
          } else {
            this.selectedStep = "PAN Verification";
          }
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$refs.toast.show("Unable to shown status of documents .", "error");
      }
    },

    async VerifyDocuments() {
      if (this.selectedStep === "PAN Verification") {
        this.validator.$validate().then(async (isValid) => {
          if (!isValid) {
            return;
          }
          this.documentVerificationSpinner = true;
          const panPayload = {
            pan: this.panNumber,
            name: this.panHolderName,
          };

          try {
            const response = await NetworkService.post(
              `pan-verification/${this.id}/${this.token}`,
              panPayload
            );
            this.$refs.toast.show(response.data[1]);
            this.documentVerificationSpinner = false;
            if (response.status === 200) {
              this.stepVerified.pan = true;
              this.selectedStep = "Aadhaar Verification";
            } else {
              this.$refs.toast.show("PAN verification failed.", "error");
            }
          } catch (error) {
            this.documentVerificationSpinner = false;
            this.$refs.toast.show("Unable to verify the PAN details.", "error");
          }
        });
      } else if (this.selectedStep === "Aadhaar Verification") {
        this.validator.$validate().then(async (isValid) => {
          if (!isValid) {
            return;
          }
          this.documentVerificationSpinner = true;
          const aadhaarPayload = {
            aadhaar_number: this.aadhaarNumber,
          };

          try {
            const response = await NetworkService.post(
              `aadhar-verification/${this.id}/${this.token}`,
              aadhaarPayload
            );
            this.documentVerificationSpinner = false;
            this.$refs.toast.show(response.data.message);
            localStorage.setItem("Ref_id", response.data.ref_id);
            if (response.status === 200) {
              this.stepVerified.aadhaar = true;
              this.$router.push({
                name: "aadhar-otp",
                query: { id: this.id, token: this.token },
              });
            } else {
              this.$refs.toast.show("Aadhaar verification failed.", "error");
            }
          } catch (error) {
            this.documentVerificationSpinner = false;
            this.$refs.toast.show("Aadhaar verification failed.", "error");
          }
        });
      } else if (this.selectedStep === "GSTIN Verification") {
        this.validator.$validate().then(async (isValid) => {
          if (!isValid) {
            return;
          }
          this.documentVerificationSpinner = true;
          const gstPayload = {
            gstin: this.gstNumber,
          };

          try {
            const gstResponse = await NetworkService.post(
              `gstin-verification/${this.id}/${this.token}`,
              gstPayload
            );
            this.documentVerificationSpinner = false;
            this.$refs.toast.show(gstResponse.data.message);

            if (gstResponse.status === 200) {
              this.stepVerified.gstin = true;
              this.selectedStep = "Document Verification";
            }
          } catch (error) {
            this.documentVerificationSpinner = false;
            console.error("Error verifying GSTIN:", error);
            this.$refs.toast.show("Error occurred while verifying GSTIN.");
          }
        });
      }
    },
    async fetchDocumentList() {
      try {
        const response = await NetworkService.get(
          `document-view/${this.id}/${this.token}`
        );
        this.documentList = response || [];
      } catch (error) {
        this.$refs.toast.show("Unable to fetch document details.", "error");
      }
    },

    async verifyingSignature() {
      if (this.isAgreed) {
        if (this.isAgreed !== undefined) {
          this.requestData = {
            i_agree_check: this.isAgreed ? "1" : "0",
          };
        }
        try {
          const response = await NetworkService.post(
            `document-verification/${this.id}/${this.token}`,
            this.requestData
          );
          if (
            response.data.status === "success" &&
            response.data.signing_link
          ) {
            window.location.href = response.data.signing_link;
          } else {
            this.$refs.toast.show(
              "Document upload failed or missing signing link.",
              "error"
            );
          }
        } catch (error) {
          if (error.message) {
            this.$refs.toast.show(
              "Unable to redirect signature page.",
              "error"
            );
          } else {
            this.$refs.toast.show(
              ErrorService.getErrorMessages(error),
              "error"
            );
          }
        }
      }
    },
    BackToLogin() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>

